import type { FieldErrorProps } from '@base-ui/react';

import { Field as BaseField } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { fieldErrorStyle } from './FieldError.css';

type Props = FieldErrorProps;

export const FieldError = ({ ...delegated }: Props) => {
  return <BaseField.Error {...delegated} className={clsxs(fieldErrorStyle, delegated.className)} />;
};
